<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Analytics</span>
        <h3 class="page-title">Insights</h3>
      </div>
      <div class="col-12 col-sm-8 text-center text-sm-right">
        <d-button theme="primary" @click="createInsight">
          <i class="material-icons">add</i> New Insight
        </d-button>
      </div>
    </div>

    <!-- Insights Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">Custom Insights</h6>
          </div>
          <div class="card-body p-0 pb-3">
            <table class="table mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0">Name</th>
                  <th scope="col" class="border-0">Type</th>
                  <th scope="col" class="border-0">Data Sources</th>
                  <th scope="col" class="border-0">Splits</th>
                  <th scope="col" class="border-0">Created</th>
                  <th scope="col" class="border-0">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="insight in insights" :key="insight.id">
                  <td>
                    <strong>{{ insight.name }}</strong>
                    <br>
                    <small class="text-muted">{{ insight.description || 'No description' }}</small>
                  </td>
                  <td>
                    <span class="badge badge-info">{{ formatType(insight.type) }}</span>
                  </td>
                  <td>
                    <span class="badge badge-secondary">{{ insight.data_sources ? insight.data_sources.length : 0 }} source(s)</span>
                  </td>
                  <td>
                    <span class="badge badge-secondary">{{ insight.splits ? insight.splits.length : 0 }} split(s)</span>
                  </td>
                  <td>{{ formatDate(insight.created_at) }}</td>
                  <td>
                    <d-button size="small" outline @click="viewInsight(insight.id)">
                      <i class="material-icons">visibility</i>
                    </d-button>
                    <d-button size="small" outline @click="editInsight(insight.id)">
                      <i class="material-icons">edit</i>
                    </d-button>
                    <d-button size="small" outline theme="danger" @click="deleteInsight(insight.id)">
                      <i class="material-icons">delete</i>
                    </d-button>
                  </td>
                </tr>
                <tr v-if="insights.length === 0">
                  <td colspan="6" class="text-center text-muted py-4">
                    No insights found. Create your first insight to get started.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import insightsAPI from '@/api/insights';
import moment from 'moment';

export default {
  name: 'Insights',
  data() {
    return {
      insights: [],
      loading: false,
    };
  },
  mounted() {
    this.loadInsights();
  },
  methods: {
    loadInsights() {
      this.loading = true;
      insightsAPI.getInsights()
        .then((response) => {
          this.insights = response.data.insights || [];
        })
        .catch((error) => {
          console.error('Failed to load insights:', error);
          alert('Failed to load insights: ' + (error.response && error.response.data && error.response.data.error || error.message));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createInsight() {
      this.$router.push({ name: 'insight_new' });
    },
    viewInsight(id) {
      this.$router.push({ name: 'insight_detail', params: { id } });
    },
    editInsight(id) {
      this.$router.push({ name: 'insight_edit', params: { id } });
    },
    deleteInsight(id) {
      if (!confirm('Are you sure you want to delete this insight?')) {
        return;
      }
      insightsAPI.deleteInsight(id)
        .then(() => {
          this.loadInsights();
        })
        .catch((error) => {
          console.error('Failed to delete insight:', error);
          alert('Failed to delete insight: ' + (error.response && error.response.data && error.response.data.error || error.message));
        });
    },
    formatType(type) {
      const types = {
        bar_chart: 'Bar Chart',
        line_chart: 'Line Chart',
        area_chart: 'Area Chart',
        table: 'Table',
        top_items: 'Top Items',
        metric: 'Metric',
      };
      return types[type] || type;
    },
    formatDate(date) {
      if (!date) return '-';
      return moment(date).format('YYYY-MM-DD');
    },
  },
};
</script>

